import { useCallback, useEffect, useState } from "react";
import {
  nextPreference,
  THEME_STORAGE_KEY,
  type ThemeButton,
  type ThemePreference,
} from "./theme";

function read(): ThemePreference {
  const v = localStorage.getItem(THEME_STORAGE_KEY);
  return v === "light" || v === "dark" ? v : null;
}

/** Reflects the preference onto <html data-theme>. Absent attribute = follow system. */
function apply(pref: ThemePreference): void {
  const root = document.documentElement;
  if (pref) root.setAttribute("data-theme", pref);
  else root.removeAttribute("data-theme");
}

export function useTheme() {
  const [preference, setPreference] = useState<ThemePreference>(read);

  useEffect(() => {
    apply(preference);
    if (preference) localStorage.setItem(THEME_STORAGE_KEY, preference);
    else localStorage.removeItem(THEME_STORAGE_KEY);
  }, [preference]);

  const click = useCallback((button: ThemeButton) => {
    setPreference((current) => nextPreference(current, button));
  }, []);

  return { preference, click };
}
